import { SignupFormData } from 'modules/auth/hooks/useSignupForm'
import { Link } from 'modules/common/components/Link/Link'
import { MessageWithCheckbox } from 'modules/common/components/MessageWithCheckbox/MessageWithCheckbox'
import { useCountryExternalLinks } from 'modules/common/hooks/useCountryExternalLinks'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useFormContext } from 'react-hook-form'
import { Trans } from 'react-i18next'

export const SignupFormPasswordFieldConsentCheckbox = () => {
  const { t } = useTranslation('auth-components')

  const { control } = useFormContext<SignupFormData>()

  const externalLinks = useCountryExternalLinks()

  return (
    <MessageWithCheckbox
      id="userAcceptsTerms"
      name="userAcceptsTerms"
      label={
        <Trans
          parent="p"
          components={{
            cguLinkComponent: (
              <Link
                key="cguLink"
                href={externalLinks.cguLink}
                className="text-primary underline"
              />
            ),
            bankingPrivacyPolicyLinkComponent: (
              <Link
                key="privacyPolicy"
                href={externalLinks.bankingOrganizationPrivacyPolicyLink}
                className="text-primary underline"
              />
            ),
          }}
        >
          {t('signupForm.password.userAcceptsTerms.label')}
        </Trans>
      }
      control={control}
    />
  )
}
